import { BUILDING_GROUP_LIST_API } from '../constants/api'
import { BUILDING_GROUP_ENTITY } from '../constants/entity'
import { deleteApi, getApi, patchApi, postApi, putApi } from '../utils/api'

export function getBuildingGroupProfile(id) {
  return getApi({ endpoint: `api/${BUILDING_GROUP_ENTITY.single}/${id}/` })
}

export function updateBuildingGroupProfile({ data, id }) {
  return patchApi({
    data,
    endpoint: `api/${BUILDING_GROUP_ENTITY.single}/${id}/`,
  })
}

export function updateBuildingGroupResponsibleUsers({ data, id }) {
  return postApi({
    data,
    endpoint: `api/${BUILDING_GROUP_ENTITY.single}/${id}/responsible-users/`,
  })
}

export function getBuildingGroups(search, apiParams) {
  const params = { ...(search ? { search } : null) }

  return getApi({
    endpoint: 'idwell-api/api/v3/construction/building-group-options/',
    params: {
      ...apiParams,
      ...params,
    },
  })
}

export function getFilteredBuildingGroups(data) {
  return postApi({ data, endpoint: BUILDING_GROUP_LIST_API })
}

export function getBuildingGroupOptions(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/construction/building-group-options/',
    params,
  })
}

export function createBuildingGroup(data) {
  return postApi({ data, endpoint: `api/${BUILDING_GROUP_ENTITY.single}/` })
}

export function removeBuildingsFromBuildingGroup({ data, id }) {
  return deleteApi({
    data,
    endpoint: `api/${BUILDING_GROUP_ENTITY.single}/${id}/buildings/`,
  })
}

export function performBuildingGroupsMassAction(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/construction/${BUILDING_GROUP_ENTITY.plural}/mass-action/`,
  })
}

export function updateBuildingGroupsTableConfig(
  data,
  entityPlural = BUILDING_GROUP_ENTITY.plural
) {
  return putApi({
    data,
    endpoint: `idwell-api/api/v3/table/tables/${entityPlural}/config/`,
  })
}

export function checkBuildingGroupsExportTask(id) {
  return getApi({ endpoint: `api/building-group/export/task/${id}/` })
}

export function startBuildingGroupsExport(data) {
  return postApi({
    data,
    endpoint: 'idwell-api/api/v3/construction/building-groups/export/',
  })
}

export function loadBuildingGroupsExportFieldsList() {
  return getApi({ endpoint: 'api/building-group/export/fields-list/' })
}
